/**
 * FridgeIQ — Claude API Service
 * Auto-generates product aliases using Claude Sonnet.
 * Called silently when a product is saved — no operator input needed.
 */

/**
 * Generate aliases for a product using Claude.
 * Returns array of alias strings.
 */
export async function generateProductAliases(name, brand, category) {
  try {
    const prompt = `You are helping a smart vending fridge recognize products by name.

Generate 10-14 natural aliases for this product that a camera AI system might use to identify it:

Product: ${name}
Brand: ${brand || "Unknown"}
Category: ${category || "Unknown"}

Return ONLY a JSON array of lowercase alias strings. No explanation, no markdown, no extra text.
Include variations like:
- Short names (just the brand, just the flavor)
- Common nicknames
- Partial names people might say
- Size variations if relevant
- Flavor descriptions

Example format:
["gatorade lemon lime", "yellow gatorade", "lemon lime sports drink", "gatorade 20oz", "gatorade lemon", "lemon gatorade", "gatorade"]`;

    const response = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        model: "claude-sonnet-4-6",
        max_tokens: 1000,
        messages: [{ role: "user", content: prompt }],
      }),
    });

    const data = await response.json();
    const text = data.content?.[0]?.text || "[]";

    // Strip any markdown fences just in case
    const clean = text.replace(/```json|```/g, "").trim();
    const aliases = JSON.parse(clean);

    if (Array.isArray(aliases)) {
      return aliases.map(a => a.toLowerCase().trim()).filter(Boolean);
    }
    return [];
  } catch (err) {
    console.error("generateProductAliases error:", err);
    return [];
  }
}
